<div class="hours-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow">
            <input matInput formControlName="hours" name="string1" maxlength="255"
                placeholder="{{'hours ' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.hours-condition-editor.hours', translationService.language]}}"
                [maxlength]="255">
        </mat-form-field>
    </div>
</div>
